import mod from "-!./contact.js?vue&type=script&lang=js&"; export default mod; export * from "-!./contact.js?vue&type=script&lang=js&"